import { render } from "./FlaggedClientPostsToolbar.vue?vue&type=template&id=0c470f69&ts=true"
import script from "./FlaggedClientPostsToolbar.vue?vue&type=script&lang=ts"
export * from "./FlaggedClientPostsToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__